import React, { useState, useContext } from 'react';
import { AuthContext } from '../../app/providers/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const userData = await login({ email: username, password });
      if (userData.responsecode === 0) {
        toast.success('Giriş başarılı');
        setTimeout(() => navigate('/'), 900);
      } else {
        toast.error('Geçersiz kullanıcı adı veya şifre');
      }
    } catch (error) {
      toast.error('Giriş sırasında bir hata oluştu');
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <ToastContainer position="top-right" theme="colored" />
      <div className="login-card">
        <div className="login-brand">
          <span className="login-brand-icon">J</span>
          <span className="login-brand-name">JUBI</span>
          <span className="login-brand-tag">ERP</span>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label htmlFor="username">E-posta</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="ornek@firma.com"
              autoComplete="username"
              required
            />
          </div>

          <div className="login-field">
            <label htmlFor="password">Şifre</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          <div className="login-options">
            <label className="login-remember">
              <input type="checkbox" />
              <span>Beni hatırla</span>
            </label>
          </div>

          <button
            type="submit"
            className="login-submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="login-spinner" />
            ) : (
              'Giriş Yap'
            )}
          </button>
        </form>

        <p className="login-footer">© {new Date().getFullYear()} JUBI</p>
      </div>
    </div>
  );
};

export default Login;
